import axios from "axios"
import baseUrl from "./base"

const akunApi = {
  fetchKecamatan: async (token, data) => {
    return await axios.get(`${baseUrl}/api/kecamatan/get`,
      { params: data, headers: { Authorization: `Bearer ${token}` } }
    )
  }
}

export default akunApi